import { approach } from "../data/site";
import { Reveal } from "./motion";

export default function Approach() {
  return (
    <section className="section approach" id="approach">
      <div className="shell approach__grid">
        <div className="approach__aside">
          <p className="label">Approach</p>
          <h2 className="h2">How I work when nobody is watching.</h2>
        </div>

        <div className="approach__body">
          <ol className="approach__principles">
            {approach.principles.map((item, i) => (
              <Reveal as="li" key={item.title} delay={i * 0.08}>
                <h3 className="approach__title">{item.title}</h3>
                <p className="soft measure">{item.body}</p>
              </Reveal>
            ))}
          </ol>

          <div className="approach__tools">
            <p className="label">The bench</p>
            <dl>
              {approach.tools.map((tool) => (
                <div className="approach__tool" key={tool.name}>
                  <dt>{tool.name}</dt>
                  <dd className="soft">{tool.note}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}
